import React, { useState } from 'react';
interface IdValidationProps {
  onSubmit: (id: string) => void;
}
export function IdValidation({
  onSubmit
}: IdValidationProps) {
  const [id, setId] = useState('');
  const [error, setError] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (id.length === 15 || id.length === 18) {
      onSubmit(id);
    } else {
      setError('Voer een geldige ID in (15 of 18 karakters)');
    }
  };
  return <div className="bg-white rounded-lg shadow-lg p-6 backdrop-blur-sm bg-opacity-70" data-id="element-45">
      <h2 className="text-xl font-semibold text-[#052858] mb-4" data-id="element-46">
        Voer uw unieke ID in
      </h2>
      <form onSubmit={handleSubmit} data-id="element-47">
        <div className="mb-4" data-id="element-48">
          <label htmlFor="customer-id" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-49">
            Klant ID
          </label>
          <input type="text" id="customer-id" value={id} onChange={e => setId(e.target.value)} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#19EAC4]" placeholder="Voer uw 15 of 18 karakter ID in" data-id="element-50" />
          {error && <p className="mt-2 text-sm text-red-600" data-id="element-51">{error}</p>}
        </div>
        <button type="submit" className="w-full py-2 px-4 bg-gradient-to-r from-[#19EAC4] to-[#052858] text-white font-medium rounded-md hover:opacity-90 transition-opacity" data-id="element-52">
          Doorgaan
        </button>
      </form>
    </div>;
}